import { call, put, takeEvery } from "redux-saga/effects"
import { MONITOR_SUPPLIER_LOAD } from "./actionTypes"
import { monitorsupplierError, loadSuppliers } from "./actions"
import service from "../../../api/monitor.service"

function* loadMonitorSupplier(filter) {
  try {
    const response = yield call(service.getSupplier, filter.payload)
    yield put(loadSuppliers(response?.data))


  } catch (error) {
    yield put(monitorsupplierError(error.message))
  }
}


function* monitorSupplierSaga() {
  yield takeEvery(MONITOR_SUPPLIER_LOAD, loadMonitorSupplier)
}

export default monitorSupplierSaga
